<template>
  <div class="pre-sign-preview-wrapper">
    <div class="content">
      <div class="preview-image-box" :style="{ width: `${width}px`, height: `${height}px` }">
        <img
          class="preview-image"
          :src="imageSrc"
          :style="{ maxWidth: `${width}px`, maxHeight: `${height}px` }"
          alt=""
        />
        <vue-draggable-resizable
          class-name="sign-box"
          :parent="true"
          :resizable="false"
          :x="135"
          :y="244"
          :w="112"
          :h="38"
          @dragstop="onDragStop"
          @dragging="onDragging"
        >
          <p>药师签字区域</p>
        </vue-draggable-resizable>
        <div v-if="!isMove" :class="['sign-tip', { bounce: !isMove }]">
          <div class="arrow"></div>
          鼠标拖拽移动位置
        </div>
      </div>
      <pre-example title="药师签名区域示例" :url="require('@/assets/img/pre_eg_2.png')"></pre-example>
    </div>

    <div ref="capture" class="generator-image-box" :style="{ width: `${width}px`, height: `${height}px` }">
      <img :src="imageSrc" alt="" :style="{ maxWidth: `${width}px`, maxHeight: `${height}px` }" />
    </div>
    <div class="bottom-btn">
      <el-button type="primary" @click="_generatorImage">提交处方</el-button>
      <el-button type="primary" plain @click="onCancel">{{ cancelText }}</el-button>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import html2canvas from 'html2canvas';
import preExample from './preExample';
import debounce from 'lodash/debounce';
import { dataURLtoFile } from '@/util';
export default {
  name: 'preSignPreview',
  props: {
    width: Number,
    height: Number,
    cancelText: String,
    imageSrc: {
      type: String
    }
  },
  components: { VueDraggableResizable, preExample },
  data() {
    return {
      isMove: false
    };
  },
  methods: {
    onDragStop(x, y) {
      this.$emit('onDragStop', { x, y });
    },
    _generatorImage: debounce(
      function() {
        this.generatorImage();
      },
      500,
      {
        leading: true,
        trailing: false
      }
    ),
    generatorImage() {
      const { isMove, width, height } = this;
      if (!isMove) return this.$message.error('请先移动药师签字区域到合适区域');
      let loadingService = this.$loading({
        text: '正在努力加载中....',
        background: 'rgba(0, 0, 0, 0)'
      });
      html2canvas(this.$refs.capture, {
        useCORS: true,
        scale: 2,
        width: 368,
        height: 520,
        scrollY: 0,
        scrollX: 0,
        backgroundColor: null
      }).then(canvas => {
        const imgUrl = canvas.toDataURL();
        const file = dataURLtoFile(imgUrl, 'prescription.png');
        loadingService.close();
        this.submit(file);
      });
    },
    submit(file) {
      this.$emit('onSubmit', file);
    },
    onCancel() {
      this.$emit('onCancel');
    },
    onDragging() {
      if (!this.isMove) this.isMove = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.pre-sign-preview-wrapper {
  .content {
    display: flex;
    .preview-image-box {
      position: relative;
      margin-right: 16px;
      background: #f7f9fa;
      border-radius: 4px;
      .sign-box {
        line-height: 38px;
        text-align: center;
        background: rgba(255, 230, 173, 0.9);
        border-radius: 2px;
        border: 1px solid #ebb436;
        font-weight: 400;
        color: #b38929;
      }
      .preview-image {
        position: absolute;
        margin-left: 50%;
        transform: translateX(-50%);
      }
      .sign-tip {
        position: absolute;
        padding: 6px;
        font-size: 12px;
        background: #ffffff;
        box-shadow: 0px 4px 12px 0px rgba(51, 51, 51, 0.2);
        border: 1px solid #f2f2f2;
        z-index: 1;
        border-radius: 2px;
        top: 246px;
        left: 254px;
        .arrow {
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          bottom: 50%;
          left: -17px;
          border-color: transparent;
          border-style: solid;
          transform: translateY(-80%);
          &::after {
            content: ' ';
            border-width: 8px;
            position: absolute;
            display: block;
            width: 0;
            height: 0;
            border-color: transparent;
            border-right-color: #ffffff;
            border-style: solid;
          }
        }
      }
    }
  }
  .generator-image-box {
    position: fixed;
    top: -100%;
    img {
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
  .bottom-btn {
    margin-top: 18px;
  }
  .bounce {
    animation: bounce-in 0.5s;
  }
  @keyframes bounce-in {
    from,
    20%,
    53%,
    80%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    40%,
    43% {
      -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -30px, 0);
      transform: translate3d(0, -30px, 0);
    }
    70% {
      -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -15px, 0);
      transform: translate3d(0, -15px, 0);
    }
    90% {
      -webkit-transform: translate3d(0, -4px, 0);
      transform: translate3d(0, -4px, 0);
    }
  }
}
</style>
